/** @jsxImportSource @emotion/react */
import { FeedCard, Column, Text, TEXT_VARIANTS, Tagline } from "../..";

export const NoteCard: React.FC = () => (
  <FeedCard path="/note/id">
    <Column crossAxisAlignment="start" gap={5}>
      <Text variant={TEXT_VARIANTS.T20}>
        {
          "It’s one thing to break a database, but when that database holds the keys to interpersonal relationships the database isn’t the only thing that breaks."
        }
      </Text>
      <Tagline
        text="note · by $0 on $1"
        entities={[
          { type: "user", name: "Sari Azout" },
          { type: "article", name: "Design's Lost Generation" },
        ]}
      />
    </Column>
  </FeedCard>
);
